






































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import BigNumber from "bignumber.js";
import USD from "@/components/USD.vue";
import { OrderItemStatus } from "../../../types/enum/OrderEnum";
@Component({
  name: "check-box-table",
  components: {
    USD
  }
})
export default class CheckBoxTable extends Vue {
  colmun: Array<{ text: string; value: string; align?: string }> = [
    { text: "Food Name", align: "left", value: "name" },
    { text: "Quantity", align: "left", value: "quantity" },
    { text: "Price", align: "left", value: "subTotalExcludeTax" }
  ];

  @Prop(Array) orderItems!: IOrderItemDto[];
  @Prop({ default: true }) showSelect!: boolean;

  public get items(): IOrderItemDto[] {
    let orderItems = JSON.parse(JSON.stringify(this.orderItems));
    return orderItems.map((x: IOrderItemDto) => {
      x.subTotalExcludeTax = Number(
        new BigNumber(x.subTotalExcludeTax).plus(x.taxAmount).toFixed(2)
      );
      return x;
    });
  }

  public get isCheckedForSelectAllBox(): boolean {
    return (
      this.orderItems.filter(
        (x: IOrderItemDto) => x.status === OrderItemStatus.Normal
      ).length === this.selected.length
    );
  }

  public set isCheckedForSelectAllBox(v: boolean) {
    this.selectAll(v);
  }

  selected: Array<string> = [];

  itemSelected(isSelect: string[]) {
    this.$emit("on-select", JSON.parse(JSON.stringify(this.selected)));
  }

  selectAll(isSelectAll: boolean) {
    if (isSelectAll) {
      this.selected = this.orderItems.reduce(
        (arr: Array<string>, item: IOrderItemDto) => {
          return (item.status === OrderItemStatus.Normal || item.status === OrderItemStatus.ComplainRejected)
            ? [...arr, item.id]
            : arr;
        },
        []
      );
    } else {
      this.selected = [];
    }
    this.$emit("on-select", JSON.parse(JSON.stringify(this.selected)));
  }

  canSelect (item: IOrderItemDto) {
    return (item.status === OrderItemStatus.Normal || item.status === OrderItemStatus.ComplainRejected)
  }

  updated() {
    this.selected = [];
  }
}
